import { Icon } from "@chakra-ui/react";
import React from "react";

const FullPluginIcon = (props) => (
  <Icon viewBox="0 0 40 40" fill="none" {...props}>
    <rect x="6" y="6" width="28" height="28" rx="2" stroke="currentColor" stroke-width="2" />
  </Icon>
);

export default React.memo(FullPluginIcon);
